import React from "react";
import "../../styles/NavigationSidebar.css";

export default function NavSidebar({ activeNav, setActiveNav }) {
  const navItems = ["Dashboard", "Clinics", "Users", "Settings"];

  return (
    <div className="nav-sidebar">
      <img src="/logo.png" alt="Olumis AI Logo" className="nav-logo" />

      {navItems.map((item) => (
        <button
          key={item}
          className={`nav-button ${activeNav === item ? "active" : ""}`}
          onClick={() => setActiveNav(item)}
        >
          {item}
        </button>
      ))}

      <button className="nav-button">→Logout</button>
    </div>
  );
}
